"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Card_1 = require("@dialogexe/cw-component-quick-links-card/Card");
class QuickLinks extends React.Component {
    render() {
        const { cards } = this.props;
        return (React.createElement("div", { className: "QuickLinks" },
            React.createElement("div", { className: "row is-spaced" }, cards.map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6" },
                React.createElement(Card_1.Card, { link: card.link, icon: card.icon, title: card.title, text: card.text, openInNewTab: card.openInNewTab })))))));
    }
}
exports.QuickLinks = QuickLinks;
exports.default = QuickLinks;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-quick-links/QuickLinks.tsx